module.exports = __webpack_public_path__ + "img/Sophia.467b1da7.jpg";